var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"oil-lic-menu"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.goToLock()}}},[_vm._v("\n\t\t"+_vm._s(item)+"\n\t")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }